import api from '@/api'
import errors from '@/api/errors'
import store from '@/store'

const baseUrlRef = process.env.REVIEW_API_BASE_URL_REF

const createGetItemVariationParams = (args) => {
  const p = {}
  p.sessionID = store.getters['commons/cookies'].encsid
  p.sku_code = args.skuCode
  return p
}

const onReceived = (respBody) => {
  if (respBody.resultCode !== 0) {
    console.error(`API error code ${respBody.resultCode}`)
    if (respBody.resultCode === 611) { // アクセストークンエラー
      throw new errors.AuthenticationError()
    }
    throw new Error('問題が発生したためその後の処理を継続することができませんでした。時間を置いて再度利用をお願いします。')
  }
  if (respBody.sku.length < 1) {
    console.error('not exist this sku')
    throw new Error('お探しの商品は見つかりませんでした。')
  }
  return Promise.resolve({ sku: respBody.sku, item_code: respBody.item_code })
}

export default {
  // sku情報取得
  getItemVariation: (args) => {
    const params = createGetItemVariationParams(args)
    return api.post(`${baseUrlRef}/getItemVariation`, params).then(onReceived)
  }
}



// WEBPACK FOOTER //
// ./src/api/items.js